import {
  ROLE_DEALER,
  ROLE_ARCHITECT,
  ROLE_GENERAL_CONTRACTOR,
} from "@/data/roleData";
export default {
  allRole: () => {
    return [ROLE_DEALER, ROLE_ARCHITECT, ROLE_GENERAL_CONTRACTOR];
  },
};
